import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CATEGORIAS } from './types';
import { RootState } from "@/store/modules/general/types";
import { state } from './state';

const namespaced = true;

type CategoriaModule = Module<CATEGORIAS, RootState>;

export const ventas: CategoriaModule = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
}